import { EmojiContainer, IconContainer, Title } from "./Emoji.styles";

const Emoji = function ({ bgColor, Icon, title, onClick }) {
  return (
    <EmojiContainer onClick={onClick} >
      <IconContainer bgColor={bgColor}>{Icon && <Icon />}</IconContainer>
      <Title>{title}</Title>
    </EmojiContainer>
  );
};

Emoji.propTypes = {};

export default Emoji;
